import { getLogger } from '../../../../util/logger';
import {
  addNewPrompt,
  applyDefaultPrompt,
  removeNewPrompt,
} from '../../utils/settingsUtils';

const logger = getLogger('slidePromptUtils');

export const handleImageChange = (
  event,
  name,
  defaultSlideUrl,
  setPromptChanges,
  setSubmitEnabled,
  setFieldValue,
) => {
  logger.debug(event.currentTarget.files[0]);
  setFieldValue(name, event.currentTarget.files[0]);
  addNewPrompt(
    setPromptChanges,
    setSubmitEnabled,
    defaultSlideUrl,
    event.currentTarget.files[0],
    true,
  );
};

export const handleImageLoad = (
  imgRef,
  setPromptError,
  setShowPromptError,
  clearSlide,
) => {
  let errorMsg = null;
  try {
    if (
      imgRef.current &&
      (imgRef.current.naturalWidth !== 1920 ||
        imgRef.current.naturalHeight !== 1080)
    ) {
      errorMsg = `Invalid image dimensions ${imgRef.current.naturalWidth} x ${imgRef.current.naturalHeight}`;
    }
  } finally {
    if (errorMsg != null) {
      setPromptError({
        title: 'Invalid Slide',
        message: errorMsg,
        isSlide: true,
      });
      setShowPromptError(true);
      clearSlide();
    }
  }
};

export function clearCustomSlide(
  name,
  isNew,
  imgRef,
  slideUrl,
  defaultSlideUrl,
  currentSlideUrl,
  setPromptChanges,
  clearInputValue,
  setFieldValue,
  setCurrentSideUrl,
) {
  if (isNew) {
    URL.revokeObjectURL(imgRef.current.src);
    setFieldValue(name, undefined);
    clearInputValue();
    if (slideUrl !== defaultSlideUrl && currentSlideUrl === defaultSlideUrl) {
      applyDefaultPrompt(setPromptChanges, defaultSlideUrl, true);
    } else {
      removeNewPrompt(setPromptChanges, defaultSlideUrl);
    }
  } else {
    setCurrentSideUrl(defaultSlideUrl);
    applyDefaultPrompt(setPromptChanges, defaultSlideUrl, true);
  }
}
